import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";

import { htmlMarkup } from "widgets/richtext";

import styles from "./style.css";

window.htmlMarkup = htmlMarkup;

function TextAreaComponent({ value, style, onDoubleClick }) {
  const formattedValue = useMemo(
    function formatValue() {
      return value && typeof value === "string"
        ? { __html: htmlMarkup(value) }
        : null;
    },
    [value]
  );
  return (
    <span
      className={`${styles.textarea}`}
      style={style}
      dangerouslySetInnerHTML={formattedValue}
      onDoubleClick={onDoubleClick}
    />
  );
}

TextAreaComponent.propTypes = {
  value: PropTypes.string,
  style: PropTypes.any,
  onDoubleClick: PropTypes.func
};

export const TextArea = memo(TextAreaComponent);
